import { render, staticRenderFns } from "./CreateSuccessful.vue?vue&type=template&id=5cdec9fb&scoped=true"
import script from "./CreateSuccessful.vue?vue&type=script&lang=js"
export * from "./CreateSuccessful.vue?vue&type=script&lang=js"
import style0 from "./CreateSuccessful.vue?vue&type=style&index=0&id=5cdec9fb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdec9fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cdec9fb')) {
      api.createRecord('5cdec9fb', component.options)
    } else {
      api.reload('5cdec9fb', component.options)
    }
    module.hot.accept("./CreateSuccessful.vue?vue&type=template&id=5cdec9fb&scoped=true", function () {
      api.rerender('5cdec9fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/sub-merchant/components/content/payment-link/components/Modal/CreateSuccessful.vue"
export default component.exports